/* eslint-disable react/jsx-no-bind */

import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export const SubNavBar = (props: React.PropsWithChildren) => {
  return (
    <nav className="z-20 flex h-[44px] gap-3 border-b border-b-gray-400 bg-slate-100 px-2.5 shadow-sm">
      {props.children}
    </nav>
  );
};

export const SubNavLink = (props) => {
  return (
    <NavLink
      {...props}
      className={({ isActive }) =>
        twMerge(
          classNames(
            "self-center px-2 py-1 text-sm",
            "flex items-center justify-center rounded-md border border-gray-500",
            "text-charcoal-400 no-underline hover:text-current hover:no-underline focus:text-current focus:no-underline",
            "transition-colors duration-75 hover:border-slate-400 hover:bg-white",
            {
              "text-charcoal-700 border-slate-500 bg-white shadow-sm": isActive,
            },
          ),
        )
      }
    />
  );
};
